import React, { FC, useEffect } from "react";

import { useAppSelector } from "../../../redux/redux";
import { getLinkedFirm } from "../../../sessionStorage/sessionStorage";
import { useLazyGetRefreshedTokenQuery } from "../../../slices/QboSlice";
import { HomeWorksPage } from "./HomeWorksPage";

export const HomeMyWorks: FC = () => {
  const userId = useAppSelector((state) => state.appReducer.user?.id);
  const orgId = getLinkedFirm()?.orgId;

  const [getQboToken] = useLazyGetRefreshedTokenQuery();

  useEffect(() => {
    if (!orgId || !userId) return;

    const fetchToken = async () => {
      try {
        await getQboToken({ orgId, userId }).unwrap();
      } catch (error) {
        console.error("Failed to fetch token:", error);
      }
    };

    void fetchToken();

    const intervalId = window.setInterval(fetchToken, 55 * 60 * 1000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [getQboToken, orgId, userId]);

  return <HomeWorksPage title={"My work"} isMyWork />;
};
